import { Injectable } from "@angular/core";
import { MessageService, MessageContent } from "./message.service";
import { BehaviorSubject } from "rxjs";
import { Document } from "../document/document.service";

@Injectable({
  providedIn: "root",
})
export class MessageCardService {
  public showHelpCard = new BehaviorSubject(false);
  constructor(private messageService: MessageService) {}

  sendReportingSubmitCard(reportingDate: number) {
    const messageContent = {
      message: {
        type: 6,
        text: "Reporting sumitted",
        metadata: {
          reportingDate,
        },
        id: new Date().getTime() + "-" + Math.random(),
      },
      state: undefined,
      form: undefined,
    } as MessageContent;
    this.messageService.sendMessage(messageContent);
  }
  sendVitalSubmitCard(selectedDate: number) {
    const messageContent = {
      message: {
        type: 8,
        text: "Vitals sumitted",
        metadata: {
          vitalsDate: selectedDate,
        },
        id: new Date().getTime() + "-" + Math.random(),
      },
      state: undefined,
      form: undefined,
    } as MessageContent;
    this.messageService.sendMessage(messageContent);
  }
  sendDocumentCard(document: Document) {
    const messageContent = {
      message: {
        type: document.format === 4 ? 3 : 2,
        text: "" + document.id,
        metadata: {
          id: document.id,
        },
        id: new Date().getTime() + "-" + Math.random(),
      },
      state: undefined,
      form: undefined,
    } as MessageContent;

    this.messageService.sendMessage(messageContent);
  }
  sendActionMessage(actionName) {
    if (actionName === "HELP") {
      this.showHelpCard.next(!this.showHelpCard.value);
    }
    //this.messageService.updateMessages([message]);
  }
}
